const form: HTMLFormElement | null = document.querySelector("#form");
const inputs: NodeListOf<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement> = document.querySelectorAll(
  "#form input, #form select, #form textarea",
);
if (form !== null) {
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const values = Array.from(inputs)
      .filter((input) => input.type != "submit")
      .map((input) => {
        const label = document.querySelector(`label[for=${input.id}]`)?.textContent;
        return { id: input.id, value: input.value, label: label ? label : null };
      });
    alert(
      values.reduce(
        (accumulator, input) => accumulator + `${input.label ? input.label : input.id}: ${input.value}\n`,
        "",
      ),
    );
    console.table(values);
  });
}
